import React, { useState, useEffect } from "react";

export const Navigation = (props) => {
  // 1. Buat state untuk menyimpan status tema
  const [isDarkMode, setIsDarkMode] = useState(false);

  // 2. Efek untuk menempelkan class 'dark-theme' ke tag <body>
  useEffect(() => {
    if (isDarkMode) {
      document.body.classList.add("dark-theme");
    } else {
      document.body.classList.remove("dark-theme");
    }
  }, [isDarkMode]);

  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            {" "}
            <span className="sr-only">Toggle navigation</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
          <a className="navbar-brand page-scroll" 
            href="#page-top"
            style={{ display: "flex", alignItems: "center" }}
          >
            <img
              src="img/black.png"
              alt="Logo Reel Seven"
              style={{ height: "40px", marginRight: "10px" }}
            />
            Reel Seven Organizer
          </a>{" "}
        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            <li>
              <a href="#about" className="page-scroll">
                About
              </a>
            </li>
            <li>
              <a href="#services" className="page-scroll">
                Services
              </a>
            </li>
            <li>
              <a href="#portfolio" className="page-scroll">
                Gallery
              </a>
            </li>
            <li>
              <a href="#testimonials" className="page-scroll">
                Testimonials
              </a>
            </li>
            <li>
              <a href="#team" className="page-scroll">
                Team
              </a>
            </li>
            <li>
              <a href="#contact" className="page-scroll">
                Contact
              </a>
            </li>
            {/* 3. Tombol Toggle Dark Mode */}
            <li>
              <button
                onClick={() => setIsDarkMode(!isDarkMode)}
                style={{
                  margin: "10px 15px",
                  background: isDarkMode ? "#444" : "#f4f4f4",
                  color: isDarkMode ? "#fff" : "#333",
                  border: "1px solid #ccc",
                  borderRadius: "20px",
                  padding: "6px 16px",
                  cursor: "pointer",
                  fontWeight: "bold",
                  transition: "all 0.3s ease"
                }}
              >
                {isDarkMode ? " Light" : " Dark"}
              </button>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};